import { CheckoutProps } from './types';
import { StyledCheckout } from './style';

function Checkout({ children }: CheckoutProps) {
    return (
        <StyledCheckout className="checkout-page">{children}</StyledCheckout>
    );
}

export default Checkout;
